module.exports = __webpack_public_path__ + "img/requested_dating.cc901646.svg";